import { render, staticRenderFns } from "./TermsModalContent.vue?vue&type=template&id=73677eea&scoped=true&"
import script from "./TermsModalContent.vue?vue&type=script&lang=ts&"
export * from "./TermsModalContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73677eea",
  null
  
)

export default component.exports